import React from 'react'
import { Typography } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'
import clsx from 'clsx'

const useStyles = makeStyles(({ typography, palette }) => {
  return {
    root: ({ underline }) => ({
      ...typography.heading.h4,
      color: palette.grey.shade[100],
      ...(underline && { marginBottom: 3 })
    })
  }
})

// Merges the caller's `classes` prop (e.g. `topicsSectionHeader`,
// `videoSectionHeader` from home-card/style.js) with the internal base
// styles. Without this merge, callers couldn't override the default
// dark-gray color — every section header would render black regardless
// of the parent card's brand surface.
const SectionHeader = props => {
  const classes = useStyles(props)
  const { underline, children, classes: classesProp = {} } = props
  return (
    <>
      <Typography
        component='h2'
        variant='h4'
        className={clsx(classes.root, classesProp.root)}
      >
        {children}
      </Typography>
      {underline}
    </>
  )
}

export default SectionHeader
